import { signalStore, withState } from '@ngrx/signals';
import { Direction } from '../../enum';
import { Measure } from '../../model';
import { MeasureService } from '../../services';
import { initialState, withCommonMethods, withCrudMethods } from '../../state';

const initState = initialState<Measure>({ direction: Direction.ASC });
export const MeasuresStore = signalStore(withState(initState), withCrudMethods(MeasureService), withCommonMethods());
